@if (!minimized) {
  <div class="panel">
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div
          class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {{ sidebarFilter | titleByContactsFilter: containerName: true }}
          @if (isAdvancedSearchApplied()) {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
          >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'contacts') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appContactsListContextMenu
            [appContactsListContextMenuWithAdvancedSearch]="true"
          />
        }
        @if (selectedTab === 'groups') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appGroupsListContextMenu
            [appGroupsListContextMenuWithAdvancedSearch]="true"
          />
        }
      </div>
      @if (listState === 'tabs') {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [value]="selectedTab"
          (valueChange)="handleSelectedTabChange($event)"
        />
      }
    </div>
    <div class="panel-list">
      @if (selectedTab === 'contacts' && contactsFilters) {
        <app-contacts-list
          [filters]="contactsFilters"
          [tenantItems]="listTenantItems"
          [debug]="debug"
          [showLocationBadge]="isAdvancedSearchApplied()"
          (loadInProgress)="loading = $event"
          (openContact)="handleClickContact($event)"
          (clickContact)="handleClickContact($event)"
          (doubleClickContact)="handleDoubleClickContact($event)"
        />
      }
      @if (selectedTab === 'groups' && groupsFilters) {
        <app-groups-list
          [filters]="groupsFilters"
          [tenantItems]="listTenantItems"
          [debug]="debug"
          (loadInProgress)="loading = $event"
          (openGroup)="handleClickGroup($event)"
          (openContact)="handleClickContact($event)"
          (clickGroup)="handleClickGroup($event)"
          (doubleClickGroup)="handleDoubleClickGroup($event)"
        />
      }
    </div>
  </div>
}
